export default function (axios, config) {
  const importMap = function (row) {
    const queen = {
      id: row.id,
      title: row.title,
      slipyear: row.field_slipyear ? row.field_slipyear.slice(0, 4) : null,
      marked: !!row.field_marked,
      parentage: row.field_origin,
      mating: row.field_mating,
      matingDetail: row.field_mating_note
    }

    queen.crownColor = config.getCrownColor(queen.slipyear)
    return queen
  }

  return {
    invalidate () {
      this.getAll.invalidate()
      this.getOne.invalidate()
    },
    getAll: config.cachedFunction(async function () {
      const listResponse = await axios({
        url: config.serverUrl + '/api/nodes/queen?_format=json',
        method: 'get',
        withCredentials: true
      })

      return Promise.all(Object.values(listResponse.data.result).map(async function (row) {
        return importMap(row)
      }))
    }),
    getOne: config.cachedFunction(async function (id) {
      const detailsResponse = await axios({
        url: config.serverUrl + '/api/node/' + id + '?_format=json',
        method: 'get',
        withCredentials: true
      })

      if (!detailsResponse.data.result) return null

      const row = Object.values(detailsResponse.data.result)[0]
      return importMap(row)
    }),
    async save ({ id, colony, title, slipyear, marked, parentage, mating, matingDetail, token }) {
      this.invalidate()
      const data = {
        title,
        field_slipyear: slipyear,
        field_marked: marked,
        field_origin: parentage,
        field_mating: mating,
        field_mating_note: matingDetail
      }

      const url = (id ? config.serverUrl + '/api/node/' + id + '?_format=json' : config.serverUrl + '/api/node/queen?_format=json')

      const queenResult = await axios({
        url,
        method: (id ? 'patch' : 'post'),
        data: data,
        withCredentials: true,
        headers: {
          'X-CSRF-Token': token
        }
      })

      const row = Object.values(queenResult.data.result)[0]

      const colonyData = {
        field_massnahmen_und_aktionen: [
          {
            type: 'aktion_neue_koenigin',
            field_koenigin: row.id
          }
        ]
      }

      await axios({
        url: config.serverUrl + '/api/node/' + colony + '?_format=json',
        method: 'patch',
        data: colonyData,
        withCredentials: true,
        headers: {
          'X-CSRF-Token': token
        }
      })

      return queenResult
    },
    deleteItem ({ id, token }) {
      this.invalidate()
      const url = config.serverUrl + '/api/node/' + id + '?_format=json'

      return axios({
        url,
        method: 'delete',
        withCredentials: true,
        headers: {
          'X-CSRF-Token': token
        }
      })
    }
  }
}
